<template>
  <div class="h-screen">
    <Header selected="preview" class="fixed w-full fixed z-50" />
    <div class="pt-8">
      <div ref="main" class="h-screen w-screen"></div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from "vuex";
import { AppService } from "../store/app.service";

export default {
  name: "Preview",
  components: {},
  data() {
    return {
      code: []
    };
  },
  mounted() {
    const newMain = this.rootNode.cloneNode(true);
    newMain.setAttribute("class", "h-screen w-screen");
    const all = Array.from(newMain.querySelectorAll(".outline"));
    for (let key in all) {
      const el = all[key].classList;
      el.remove("outline");
      el.remove("outline-select");
    }
    this.$refs.main.appendChild(newMain.children[0]);
  },
  computed: {
    ...mapGetters(["rootNode"])
  },
  methods: {
    ...mapActions(["login", "editTemplate"])
  }
};
</script>

<style lang="css">
</style>
